import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { patch } from '@ngxs/store/operators';


export class PersonalDataStateModel {
  gender?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  birthDate?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  customerType?: string | undefined;
  existingContactDetails?: any | undefined;
  address?: string | undefined; // Added address field
  customerNumber?: string | undefined;
}

export class UpdatePersonalDataState {
  static readonly type = '[PersonalDataState] Update Personal Data State';
  constructor(public payload: PersonalDataStateModel) {}
}

@State<PersonalDataStateModel>({
  name: 'personalData',
  defaults: {
    gender: '',
    firstName: '',
    lastName: '',
    birthDate: '',
    email: '',
    phoneNumber: '',
    customerType: '',
    address: '', // Initialize address field
    existingContactDetails: undefined,
  },
})
@Injectable()
export class PersonalDataState {
	
  @Selector()
  static getData(state: PersonalDataStateModel) {
    return state;
  }

  @Action(UpdatePersonalDataState)
  updatePersonalDataState(
    context: StateContext<PersonalDataStateModel>,
    action: UpdatePersonalDataState
  ) {
    context.setState(patch<PersonalDataStateModel>(action.payload));
  }
}
